import { RootState } from '../Store';

export const getIsCopyToolOpen = (state: RootState): boolean =>
  state.copyToolReducer.isOpen;

/** Whether a copy just saved into this paddock, ticked in the farm tree for a moment. */
export const getIsPaddockCopied = (state: RootState, paddockId: string) =>
  !!state.copyToolReducer.copiedPaddocks[paddockId];

/** Whether a copy just saved this document, ticked in the farm tree for a moment. */
export const getIsInputCopied = (state: RootState, inputId: string) =>
  !!state.copyToolReducer.copiedInputs[inputId];

/** Whether a running copy still has to write this document. */
export const getIsCopyingIntoInput = (
  state: RootState,
  inputId: string | null
): boolean => !!inputId && !!state.copyToolReducer.copyingInputs[inputId];

/** Whether a copy or a Retry is still running; only one runs at a time. */
export const getIsCopyRunning = (state: RootState): boolean =>
  state.copyToolReducer.isCopyRunning;
